/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/**
 * Created by WJX on 2017/11/9.
 */
// TODO: vux
import XInput from 'vux/src/components/x-input';
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import XButton from 'vux/src/components/x-button';
import XAddress from 'vux/src/components/x-address';
import PopupPicker from 'vux/src/components/popup-picker'; // import {  Group, Cell, XInput, XButton, XAddress, PopupPicker } from 'vux'

import myHospital from '@/components/pickers/hospitalPicker.vue';
import { userInfoRecord } from '@/api/ajax';
export default {
  name: '',
  data: function data() {
    return {
      code: '',
      // 验证码
      userName: '',
      // 用户名
      codeBtText: '获取验证码',
      // 验证码状态
      canSubmit: false,
      // 是否提交
      addressData: [],
      addressValue: [],
      identData: [],
      identValue: [],
      departmentData: [],
      departmentValue: [],
      dutyData: [],
      dutyValue: [],
      hospitalObj: {},
      showHospitalPicker: false,
      wxUserInfo: {},
      companyName: '',
      duties: '',
      active_index: '',
      userInfo: {}
    };
  },
  methods: {
    /*
     * 点击医院
     * 如果地区为空则提示
     * */
    showHospital: function showHospital() {
      if (!this.addressValue[2]) {
        this.$vux.toast.show({
          text: '请输入地区',
          type: 'cancel',
          width: '5rem'
        });
      } else {
        this.showHospitalPicker = !this.showHospitalPicker;
      }
    },

    /*
     * 提交
     * */
    submitBt: function submitBt() {
      var _this = this;

      if (!this.addressValue[2] || !this.departmentValue[0] || !this.dutyValue[0] || !this.hospitalObj.fullName) {
        this.$vux.toast.show({
          text: '请填写完整信息',
          type: 'cancel',
          width: '5rem'
        });
      } else {
        this.$vux.toast.show({
          text: '成功',
          width: '5rem'
        });
        var userStorage = this.$api.getStorage('wxUserInfo');
        var globelUserInfo = {
          provinceId: this.addressValue[0],
          cityId: this.addressValue[1],
          districtId: this.addressValue[2],
          identId: this.identValue[0],
          userId: userStorage.id,
          id: userStorage.id,
          wxOpenId: userStorage.wxOpenId
        };
        var doctor = {
          dutyId: this.dutyValue[0],
          departmentId: this.departmentValue[0],
          companyName: this.identValue[0] == 1 || this.identValue[0] == 2 || this.identValue[0] == 3 ? this.hospitalObj.fullName : this.companyName,
          hospitalId: this.hospitalObj.id,
          duties: this.identValue[0] == 4 || this.identValue[0] == 5 ? this.duties : ''
        };
        var perfectData = Object.assign(globelUserInfo, doctor); //混合提交数据

        userInfoRecord(perfectData).then(function (res) {
          if (res.data.status == 200) {
            _this.$api.setStorage('wxUserInfo', Object.assign(userStorage, perfectData)); //更新缓存数据

          } else {
            _this.$vux.toast.show({
              text: '出现错误请充实',
              type: 'cancel',
              width: '5rem'
            });
          }
        });
      }
    },
    departmentChange: function departmentChange(e) {// console.log(e)
      // console.log(this.$refs.department.getNameValues())
    },
    identChange: function identChange(item, index) {
      var _this2 = this; // console.log(item)


      this.identValue[0] = item.value;
      this.departmentValue = [];
      this.hospitalObj = {};
      this.$jsonp('http://cdn.yxvzb.com/dicData/_duty.json', {
        name: 'callback_cdn_duty'
      }, function (err, res) {
        var newArr = [];
        res.forEach(function (item2) {
          // console.log(item)
          if (item.value == '1') {
            if (item2.first == '医生') {
              // console.log(1)
              newArr.push({
                name: item2.second,
                value: item2.id + '',
                parent: 0
              });
            }
          } else if (item.value == '2') {
            if (item2.first == '护士') {
              newArr.push({
                name: item2.second,
                value: item2.id + '',
                parent: 0
              });
            }
          } else if (item.value == '3') {
            if (item2.first == '药剂师') {
              newArr.push({
                name: item2.second,
                value: item2.id + '',
                parent: 0
              });
            }
          }
        });
        _this2.dutyData = newArr; // console.log(this.dutyData)
      });
    },
    addressChange: function addressChange(e) {
      if (e) {
        this.hospitalObj = {};
      }
    },
    saveHospital: function saveHospital(val) {
      if (typeof val == 'string') {
        //如果是填写的则添加fullIn属性
        this.hospitalObj.fullIn = val;
        this.hospitalObj.fullName = val;
      } else {
        // 选择的医院对象
        this.hospitalObj = val;
      }

      this.showHospitalPicker = false;
    },
    init: function init() {
      this.userInfo = this.$api.getStorage('wxUserInfo');

      if (this.userInfo.provinceId && this.userInfo.cityId && this.userInfo.districtId && this.userInfo.ident) {
        this.addressValue[0] = this.userInfo.provinceId;
        this.addressValue[1] = this.userInfo.cityId;
        this.addressValue[2] = this.userInfo.districtId;

        if (this.userInfo.identId) {
          this.identValue[0] = this.userInfo.identId;
        } else {
          if (this.userInfo.ident == '医生') {
            this.identValue[0] = 1;
          } else if (this.userInfo.ident == '护士') {
            this.identValue[0] = 2;
          } else if (this.userInfo.ident == '药剂师') {
            this.identValue[0] = 3;
          } else if (this.userInfo.ident == '医学生') {
            this.identValue[0] = 4;
          } else {
            this.identValue[0] = 5;
          }
        }

        this.hospitalObj.fullName = this.userInfo.companyName;
        this.hospitalObj.id = this.userInfo.hospitalId;
        this.departmentValue[0] = this.userInfo.departmentId;
        this.dutiesObj.name = this.userInfo.duties;
        this.dutiesObj.id = this.userInfo.dutyId;
        this.companyName = this.userInfo.companyName;
        this.duties = this.userInfo.duties;
      }
    }
  },
  computed: {},
  components: {
    Group: Group,
    PopupPicker: PopupPicker,
    Cell: Cell,
    XInput: XInput,
    XButton: XButton,
    XAddress: XAddress,
    myHospital: myHospital
  },
  created: function created() {
    var _this3 = this;

    this.wxUserInfo = this.$api.getStorage('wxUserInfo');
    this.init(); // 初始化身份信息

    /*
     * 省市县
     * */

    this.$jsonp('http://cdn.yxvzb.com/dicData/_area.json', {
      name: 'callback_cdn_area'
    }, function (err, res) {
      var newArr = [];
      res.forEach(function (item) {
        var o = {
          name: item.areaName,
          value: item.id + ''
        };
        var p = {
          parent: item.parentId + ''
        };
        newArr.push(item.parentId === 0 ? o : Object.assign(o, p));
      });
      _this3.addressData = newArr;
      _this3.addressValue = ['1', '2', '3'];
    });
    /*
     * 科室
     * */

    this.$jsonp('http://cdn.yxvzb.com/dicData/_department.json', {
      name: 'callback_cdn_department'
    }, function (err, res) {
      var newArr = [];
      res.forEach(function (item) {
        newArr.push({
          name: item.second,
          value: item.id + '',
          parent: 0
        });
      });
      _this3.departmentData = newArr;
      _this3.departmentValue = ['1289'];
    });
    /*
     * 职称
     * */

    this.$jsonp('http://cdn.yxvzb.com/dicData/_duty.json', {
      name: 'callback_cdn_duty'
    }, function (err, res) {
      var newArr = [];
      res.forEach(function (item) {
        newArr.push({
          name: item.second,
          value: item.id + '',
          parent: 0
        });
      });
      _this3.dutyData = newArr;
      _this3.dutyValue = ['1'];
    });
    /*
     * 身份
     * */

    this.$jsonp('http://cdn.yxvzb.com/dicData/_identity.json', {
      name: 'callback_cdn_identity'
    }, function (err, res) {
      var newArr = [];
      res.forEach(function (item) {
        newArr.push({
          name: item.name,
          value: item.id + '',
          picUrl: item.picUrl
        });
      });
      _this3.identData = newArr; // console.log(this.identData)

      _this3.identValue = ['1'];
    });
  }
};